import "./lib/error-tracking";

import "../css/site.less";
import '../css/login.less'

import Alpine from "alpinejs";
import MicroModal from "micromodal";
import "./polyfills";
import './safearea'

window.Alpine = Alpine;
Alpine.start();

// disable turbo drive
window.MicroModal = MicroModal;

import("./lib/app-colors").then(() => {
    window.setAppColors("#E4017A");
});

// clear (old) stored cache:
localStorage.clear();